import React from 'react';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';

const StoryMedicationReviewBadge = ({ count = 0, onClick = null }) => {
  if (!count) return null;

  const label = `${count} medication ${count === 1 ? 'review' : 'reviews'} needed`;
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') onClick?.(event);
  };

  return (
    <Box
      component="span"
      role="button"
      tabIndex={0}
      aria-label={label}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      sx={{
        px: 0.75,
        py: 0.25,
        borderRadius: 999,
        border: `1px solid ${alpha(colors.brand.deep, 0.3)}`,
        color: colors.brand.deep,
        bgcolor: alpha(colors.brand.deep, 0.07),
        fontSize: '0.68rem',
        fontWeight: 800,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
      }}
    >
      {label}
    </Box>
  );
};

export default StoryMedicationReviewBadge;
